/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  PrinterStatusDTO,
  PrinterStatusDTOOptional,
  PrinterStatusDTOMetaI,
  PrinterStatusDTOTrackedI,
} from "./printer-status-dto";
import {
  PrinterStatusDTOTracked,
  PrinterStatusDTOMeta,
} from "./printer-status-dto";

/**
 *
 * @export
 * @interface PrinterComputed
 */
export interface PrinterComputedOptional {
  /**
   *
   * @type {boolean}
   * @memberof PrinterComputed
   */
  printerHasPassword?: boolean;
  /**
   *
   * @type {PrinterStatusDTO}
   * @memberof PrinterComputed
   */
  printerStatus?: PrinterStatusDTOOptional;
  /**
   *
   * @type {string}
   * @memberof PrinterComputed
   */
  ip?: string;
  /**
   *
   * @type {string}
   * @memberof PrinterComputed
   */
  model?: string;
}

export interface PrinterComputed extends PrinterComputedOptional {
  /**
   *
   * @type {boolean}
   * @memberof PrinterComputed
   */
  printerHasPassword?: boolean;
  /**
   *
   * @type {PrinterStatusDTO}
   * @memberof PrinterComputed
   */
  printerStatus?: PrinterStatusDTO;
  /**
   *
   * @type {string}
   * @memberof PrinterComputed
   */
  ip?: string;
  /**
   *
   * @type {string}
   * @memberof PrinterComputed
   */
  model?: string;
}

export interface PrinterComputedTrackedI {
  /**
   *
   * @type {boolean}
   * @memberof PrinterComputed
   */
  printerHasPassword?: boolean;
  printerHasPasswordIsSet: boolean;
  /**
   *
   * @type {PrinterStatusDTO}
   * @memberof PrinterComputed
   */
  printerStatus?: PrinterStatusDTOTrackedI;
  printerStatusIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PrinterComputed
   */
  ip?: string;
  ipIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PrinterComputed
   */
  model?: string;
  modelIsSet: boolean;
}

transformDatesMap.set("PrinterComputed", function (model: PrinterComputed) {
  const transformDatesprinterStatus = transformDatesMap.get("PrinterStatusDTO");
  if (transformDatesprinterStatus && model.printerStatus) {
    transformDatesprinterStatus(model.printerStatus);
  }
});

export type PrinterComputedMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  printerHasPassword: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  printerStatus: PropertyMeta<PrinterStatusDTOMetaI>;
  //isDate: false
  //isDatetime: false
  ip: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  model: PropertyMeta<MetaTypeBase<string>>;
}>;

export var PrinterComputedMeta: PrinterComputedMetaI =
  {} as PrinterComputedMetaI;
PrinterComputedMeta = typeMeta("PrinterComputed", {
  printerHasPassword: propertyMeta(
    "printerHasPassword",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  printerStatus: propertyMeta(
    "printerStatus",
    false,
    false,
    false,
    PrinterStatusDTOMeta,
  ),
  ip: propertyMeta("ip", false, false, false, MetaTypesBase.string),
  model: propertyMeta("model", false, false, false, MetaTypesBase.string),
});

const metaI = PrinterComputedMeta;

registerMeta(() => {});

export class PrinterComputedTracked implements PrinterComputedTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  printerHasPassword__I?: boolean = undefined;
  printerHasPasswordIsSet: boolean = false;
  set printerHasPassword(v: undefined | boolean) {
    if (v !== undefined) {
      this.printerHasPassword__I = v;
      this.printerHasPasswordIsSet = true;
    } else {
      this.printerHasPassword__I = v || undefined;
      this.printerHasPasswordIsSet = false;
    }
    this.changeTracker = true;
  }
  get printerHasPassword() {
    return this.printerHasPassword__I;
  }
  printerStatus__I?: PrinterStatusDTOTracked = undefined;
  printerStatusIsSet: boolean = false;
  set printerStatus(v: undefined | PrinterStatusDTOTracked) {
    if (v !== undefined) {
      this.printerStatus__I = v;
      this.printerStatusIsSet = true;
    } else {
      this.printerStatus__I = v || undefined;
      this.printerStatusIsSet = false;
    }
    this.changeTracker = true;
  }
  get printerStatus() {
    return this.printerStatus__I;
  }
  ip__I?: string = undefined;
  ipIsSet: boolean = false;
  set ip(v: undefined | string) {
    if (v !== undefined) {
      this.ip__I = v;
      this.ipIsSet = true;
    } else {
      this.ip__I = v || undefined;
      this.ipIsSet = false;
    }
    this.changeTracker = true;
  }
  get ip() {
    return this.ip__I;
  }
  model__I?: string = undefined;
  modelIsSet: boolean = false;
  set model(v: undefined | string) {
    if (v !== undefined) {
      this.model__I = v;
      this.modelIsSet = true;
    } else {
      this.model__I = v || undefined;
      this.modelIsSet = false;
    }
    this.changeTracker = true;
  }
  get model() {
    return this.model__I;
  }
  constructor(config?: PrinterComputedOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {
    this.printerStatus?.setIds();
  }
  assignFrom(
    config: PrinterComputedOptional,
    options?: AssignOptions,
  ): PrinterComputedTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.printerHasPassword &&
      this.printerHasPasswordApplyFilter(optionsRequired.filter)
    ) {
      this.printerHasPassword = config.printerHasPassword;
      if (optionsRequired.unassign) this.printerHasPasswordIsSet = false;
      else this.printerHasPasswordIsSet = true;
    }
    if (
      config.printerStatus &&
      this.printerStatusApplyFilter(optionsRequired.filter)
    ) {
      this.printerStatus = new PrinterStatusDTOTracked(
        config.printerStatus,
        options,
      );
      if (optionsRequired.unassign) this.printerStatusIsSet = false;
      else this.printerStatusIsSet = true;
    }
    if (config.ip && this.ipApplyFilter(optionsRequired.filter)) {
      this.ip = config.ip;
      if (optionsRequired.unassign) this.ipIsSet = false;
      else this.ipIsSet = true;
    }
    if (config.model && this.modelApplyFilter(optionsRequired.filter)) {
      this.model = config.model;
      if (optionsRequired.unassign) this.modelIsSet = false;
      else this.modelIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PrinterComputedTrackedI {
    const cloned = {} as PrinterComputedTrackedI;
    if (
      this.printerHasPasswordIsSetDeep() &&
      this.printerHasPasswordApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.printerHasPasswordIsSet = true;
      cloned.printerHasPassword = this.printerHasPassword;
    } else {
      //cloned.printerHasPasswordIsSet = false
    }
    if (
      this.printerStatusIsSetDeep() &&
      this.printerStatusApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.printerStatusIsSet = true;
      cloned.printerStatus = this.printerStatus?.removeUnset(filter);
    } else {
      //cloned.printerStatusIsSet = false
    }
    if (
      this.ipIsSetDeep() &&
      this.ipApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.ipIsSet = true;
      cloned.ip = this.ip;
    } else {
      //cloned.ipIsSet = false
    }
    if (
      this.modelIsSetDeep() &&
      this.modelApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.modelIsSet = true;
      cloned.model = this.model;
    } else {
      //cloned.modelIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PrinterComputedTrackedI {
    if (!this.printerHasPasswordApplyFilter(filter))
      this.printerHasPasswordIsSet = false;

    if (!this.printerStatusApplyFilter(filter)) this.printerStatusIsSet = false;
    this.printerStatus?.unassignAll(filter);

    if (!this.ipApplyFilter(filter)) this.ipIsSet = false;

    if (!this.modelApplyFilter(filter)) this.modelIsSet = false;

    return this;
  }
  printerHasPasswordApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PrinterComputedMeta.printerHasPassword,
      PrinterComputedMeta,
      this.printerHasPassword,
      this,
    );
  }
  printerHasPasswordIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.printerHasPasswordIsSet &&
      this.printerHasPasswordApplyFilter(filter)
    )
      return true;

    return false;
  }
  printerStatusApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PrinterComputedMeta.printerStatus,
      PrinterComputedMeta,
      this.printerStatus,
      this,
    );
  }
  printerStatusIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.printerStatusIsSet && this.printerStatusApplyFilter(filter))
      return true;
    return this.printerStatus?.anySet(filter) == true;

    return false;
  }
  ipApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PrinterComputedMeta.ip, PrinterComputedMeta, this.ip, this);
  }
  ipIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.ipIsSet && this.ipApplyFilter(filter)) return true;

    return false;
  }
  modelApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PrinterComputedMeta.model,
      PrinterComputedMeta,
      this.model,
      this,
    );
  }
  modelIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.modelIsSet && this.modelApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.printerHasPasswordIsSetDeep(filter)) return true;
    if (this.printerStatusIsSetDeep(filter)) return true;
    if (this.ipIsSetDeep(filter)) return true;
    if (this.modelIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
